<template>
  <div class="background_index_news">
    <div style="height: 92vh">
      <div style="padding-top: 25vh">
        <p style="font-size: 22px">Our Advantages</p>
        <p>———</p>
        <p style="font-size: 20px;margin-bottom: 0">Over the past 12 years, SIG has focused on technology/media, </p>
        <p style="font-size: 20px">consumer/modern services, healthcare/green technologies.</p>
        <p style="font-size: 12px">We are interested in new business models, and we pay close
          attention to technology innovations,</p>
        <p style="font-size: 12px">but most important of all, we value the gift and potential of entrepreneurs.</p>
      </div>
      <div style="margin-top: 2vh">
        <a-button type="ghost">
          <router-link :to="'/news'">See More News</router-link>
        </a-button>
      </div>
    </div>
    <div class="index_down_button">
      <a-button type="ghost" shape="circle-outline" size="large">
        <template v-slot:icon>
          <DownOutlined/>
        </template>
      </a-button>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from "@ant-design/icons-vue/";

export default {
  name: 'Index_news_en_m',
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {  //跳转下一页
      document.documentElement.scrollBy({
        top: window.innerHeight,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}

</script>
<style scoped>
.background_index_news {
  background-image: url("../../../assets/background/index_news.jpg");
  height: 100vh;

  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

.index_down_button {
  height: 5vh;
  position: relative;
  bottom: 2vh;
}

</style>